<template>
  <div class="main2-content">
    <div class="panel-content">
      <div class="model-head">
        <div class="model-title">
          <div class="model-line">{{ title }} {{ titleEn }}</div>
          <div class="model-dot" v-for="item in 3" :key="item"></div>
        </div>
        <div class="btn-group">
          <div
            class="btn"
            :class="{ active: index == btnIndex }"
            v-for="(item, index) in btn"
            :key="index"
            @click="handleIndex(index)"
          >
            <div class="titel">{{ item.title }}</div>
            <div class="titleEn">{{ item.titleEn }}</div>
          </div>
        </div>
      </div>

      <!-- start 0 -->
      <div class="layout-flex" v-if="layoutShow(0)">
        <div class="layout-flex-1">
          <div class="flex-head">
            <div class="dec">
              {{ btn[this.btnIndex].dec }}
            </div>
            <div class="decEn">
              {{ btn[this.btnIndex].decEn }}
            </div>
            <div class="img0">
              <img :src="btn[this.btnIndex].img2" style="width: 100%" />
              <img
                :src="btn[this.btnIndex].img3"
                style="width: 49%; margin-right: 1%;margin-top: 10px;"
              />
              <img
                :src="btn[this.btnIndex].img4"
                style="width: 49%; margin-left: 1%;margin-top: 10px;"
              />
            </div>
          </div>
        </div>
        <div class="layout-flex-2">
          <el-collapse  v-model="activeNames"  accordion>
            <el-collapse-item
                    v-for="(item, index) in btn[this.btnIndex].list"
                    :key="index"
                    :name="index"
            >
              <template slot="title"
              >{{ item.title }} {{ item.titleEn }}</template
              >
              <div class="collapse-scroll" style="height: auto">
                <div><div v-html="item.dec"></div></div>
                <div><div v-html="item.decEn"></div></div>
              </div>
            </el-collapse-item>
          </el-collapse>
<!--          <div class="flex-head" style="padding: 0px 15px">-->
<!--            <div class="subtitle" style="color: #aa3256; padding-top: 20px">-->
<!--              {{ btn[this.btnIndex].list[0].title }}-->
<!--              {{ btn[this.btnIndex].list[0].titleEn }}-->
<!--            </div>-->
<!--            <div class="dec" style="color: #666666">-->
<!--              <div v-html="btn[this.btnIndex].list[0].dec"></div>-->
<!--            </div>-->
<!--            <div class="decEn" style="color: #666666">-->
<!--              <div v-html="btn[this.btnIndex].list[0].decEn"></div>-->
<!--            </div>-->
<!--            <div class="img">-->
<!--              <img :src="btn[this.btnIndex].img" style="width: 100%" />-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>

      <!-- start 1 -->
      <div class="layout-flex" v-if="layoutShow(1)">
        <div class="layout-flex-1">
          <div class="flex-head">
            <div class="subtitle">
              {{ btn[this.btnIndex].list[0].title }}
            </div>
            <div class="subtitle">
              {{ btn[this.btnIndex].list[0].titleEn }}
            </div>
            <div class="dec">
              {{ btn[this.btnIndex].list[0].dec }}
            </div>
            <div class="decEn">
              {{ btn[this.btnIndex].list[0].decEn }}
            </div>
            <div class="img1" style="margin-top: 0px;">
              <img :src="btn[this.btnIndex].img2" style="width: 100%" />
            </div>
          </div>
        </div>
        <div class="layout-flex-2">
          <div class="flex-head" style="padding: 0px 15px">
            <div class="subtitle">
              {{ btn[this.btnIndex].list[1].title }}
            </div>
            <div class="subtitle">
              {{ btn[this.btnIndex].list[1].titleEn }}
            </div>
            <div class="dec" >
              <div v-html="btn[this.btnIndex].list[1].dec"></div>
            </div>
            <div class="decEn" >
              <div v-html="btn[this.btnIndex].list[1].decEn"></div>
            </div>
<!--            <div class="img">-->
<!--              <img :src="btn[this.btnIndex].img" style="width: 100%" />-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config5";
export default {
  components: {},
  data() {
    return {
      ...config,
      btnIndex: 0,
      activeNames:3,
    };
  },
  beforeMount() {},
  mounted() {},
  methods: {
    layoutShow(val = 0) {
      if (val == this.btnIndex) {
        return true;
      } else {
        return false;
      }
    },
    handleIndex(index) {
      this.activeNames = 3;
      this.btnIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./common.less");
// 主题颜色
@colorValue: #ffffff;
// 描述字体颜色
@fontValue: #ffffff;
// 按钮激活字体颜色
@activeValue: #a11c44;

/deep/.el-collapse-item__header {
  color: @fontValue;
}

.collapse-scroll {
  color: @fontValue;
  // height: 150px;
  // overflow-y: auto;
}

.main2-content {
  color: @fontValue;
  background-image: url("../../assets/csr/imgs/BGtu5@2x.png");
  // background-color: @activeValue;
}

.model-head {
  .model-title {
    color: @colorValue;
    .model-line {
      border-bottom-color: @colorValue;
    }

    .model-dot {
      border-bottom-color: @colorValue;
    }
  }

  .btn-group {
    .btn {
      color: @colorValue;
      border-color: @colorValue;
    }
    .btn.active {
      color: @activeValue;
      background: @colorValue;
    }
  }
}

.flex-head {
  .subtitle {
    color: @colorValue;
  }
  .dec {
  }
  .img {
  }
}

.img0 {
  
}
.img1 {
  margin-top: 147px;
}
@media screen and (max-width: 1400px) {
  .img0 {
    margin-top: 0px;
  }
  .img1 {
    margin-top: 165px;
  }
}
</style>
